import { ModalsKey } from '@/enums/modalsKey';
import { useSearchParams } from '@starsoft/common/hooks';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export function useIsAdminEmbed() {
  const [isAdminEmbed, setIsAdminEmbed] = useState(false);
  const adminUrl = process.env.NEXT_PUBLIC_ADMIN_URL;
  const { push, locale, replace } = useRouter();
  const search = useSearchParams();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // Safe check if we're in an iframe
    const isIframe = window.self !== window.top;
    if (isIframe && adminUrl) {
      // Setup message listener for parent communication
      const messageHandler = async (event: MessageEvent) => {
        // Verify the message is from our admin domain
        if (event.origin === new URL(adminUrl).origin) {
          if (event.data === 'admin-embed-verification') {
            setIsAdminEmbed(true);
          }

          if (event.data.type === 'navigate-to-page') {
            if (event.data.page.includes('login')) {
              // AuthService.tempSetAsUnauthorized();
              // navigateToModal(ModalsKey.Login);
              search.set('modal', ModalsKey.Login);
              push({
                search: search.toString(),
              });
              return;
            }

            search.delete('modal');
            await replace({ search: search.toString() });
            push(event.data.page, undefined, { locale });
          }
        }
      };

      window.addEventListener('message', messageHandler);

      // Return cleanup function
      return () => {
        window.removeEventListener('message', messageHandler);
      };
    }
  }, [adminUrl]);

  return {
    isAdminEmbed,
  };
}
